import styled, { css } from 'styled-components';
import {
  Flex,
  isDarkThemeMixin,
  isMobileStyleMixin,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
} from '@amzn/storm-ui';

export const UtilityNavContainer = styled(Flex).attrs({
  alignItems: 'center',
  gap: 'xxsmall',
})`
  margin-inline-start: auto;
  padding-inline: ${({ theme }) => theme.spacing.base.default};
  ${isMobileStyleMixin(css`
    padding-inline: ${({ theme }) => theme.spacing.xsmall.default};
  `)};
`;

export const ExternalSwitchWrapper = styled.span`
  display: inline-flex;
  padding-inline-end: ${({ theme }) => theme.spacing.small.default};

  & button {
    :focus-visible {
      ${styleMixinInvertedFocusOutline};

      ${isMobileStyleMixin(css`
        ${styleMixinFocusOutline};
      `)};

      ${isDarkThemeMixin(css`
        ${styleMixinFocusOutline};
      `)};
    }
  }

  ${isMobileStyleMixin(css`
    padding: ${({ theme }) =>
      `0 ${theme.spacing.xxsmall.mobile} ${theme.spacing.xxsmall.mobile}`};
  `)};
`;
